<template>
  <div class="app-container">
    <el-card>
      <div slot="header" class="clearfix">
        <span>基础信息</span>
        <el-button
          style="float: right; padding: 3px 0"
          type="text"
          @click="handleBack"
          >返回</el-button
        >
      </div>
      <div class="basic-info">
        <div class="info-item">
          <label>内容类型：</label>
          <span>{{ contentTypeText }}</span>
        </div>
        <div class="info-item">
          <label>基础信息：</label>
          <div class="thumbnail-box">
            <el-image
              :src="info.coverImage || defaultThumbnail"
              alt="封面图"
              class="thumbnail"
              :preview-src-list="info.coverImage ? [info.coverImage] : []"
              fit="cover"
            />
          </div>
          <div class="article-info">
            <div class="article-name">{{ (rowItem.templateMaterialsSharePO && rowItem.templateMaterialsSharePO.title) || info.title || "--" }}</div>
            <div class="article-describe">
              {{ info.description || "--" }}
            </div>
          </div>
        </div>
        <el-row>
          <el-col :span="8">
            <span class="info-item"
              >分类：{{ info.classificationName || "--" }}</span
            >
          </el-col>
          <el-col :span="8">
            <span class="info-item">排序：{{ info.orderNo || "0" }}</span>
          </el-col>
          <el-col :span="8">
            <span class="info-item"
              >状态：{{ info.state === 1 ? "启用" : "禁用" }}</span
            >
          </el-col>
        </el-row>
        <!-- <div class="info-item">
          <label>虚拟数据配置：</label>
          <div class="virtual-data">
            <div class="info-item">浏览量：{{ info.browseNum || 0 }}</div>
            <div class="info-item">点赞量：{{ info.likeNum || 0 }}</div>
            <div class="info-item">收藏量：{{ info.collectNum || 0 }}</div>
            <div class="info-item">转发量：{{ info.forwardNum || 0 }}</div>
          </div>
          <label>实际数据配置：</label>
          <div class="virtual-data">
            <div class="info-item">浏览量：{{ info.abrowseNum || 0 }}</div>
            <div class="info-item">点赞量：{{ info.alikeNum || 0 }}</div>
            <div class="info-item">收藏量：{{ info.acollectNum || 0 }}</div>
            <div class="info-item">转发量：{{ info.aforwardNum || 0 }}</div>
          </div>
        </div> -->
      </div>
    </el-card>
    <el-card v-if="info.type != 2">
      <div slot="header" class="clearfix">
        <span>文章详情</span>
      </div>
      <div class="article-details">
        <div class="content-text" v-html="contentHtml"></div>
      </div>
    </el-card>
    <el-card v-if="info.type === 1 || info.type === 2">
      <div slot="header" class="clearfix">
        <span>分享素材</span>
      </div>
      <div class="share-materials">
        <div class="info-item">
          <label>下载素材权限:</label>
          <span>{{
            info.canDownloadMaterial === 1
              ? "允许用户下载素材"
              : "不允许用户下载素材"
          }}</span>
        </div>
        <div
          class="info-item"
          v-if="materialTextList && materialTextList.length > 0"
        >
          <label>文案:</label>
          <div class="copy-text-list">
            <span
              v-for="(text, index) in materialTextList"
              :key="index"
              class="copy-text"
              >{{ text }}</span
            >
          </div>
        </div>
        <div
          class="info-item"
          v-if="materialImgList && materialImgList.length > 0 && info.type === 1"
        >
          <label>图片:</label>
          <div class="image-gallery">
            <el-image
              v-for="(img, index) in materialImgList"
              :key="index"
              :src="typeof img === 'string' ? img : img.url || img"
              :alt="`分享图片${index + 1}`"
              class="share-image"
              :preview-src-list="materialImgList.map(item => typeof item === 'string' ? item : item.url || item)"
              fit="cover"
            />
          </div>
        </div>
      </div>
    </el-card>

  </div>
</template>

<script>
import templateMaterialsShareApi from "@/api/marketing/templateMaterialsShare";

export default {
  props: {
    rowItem: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      info: {},
      materialTextList: [],
      materialImgList: [],
      videoList: [],
      contentHtml: "",
      defaultThumbnail:
        "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDIwMCAxMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSIyMDAiIGhlaWdodD0iMTIwIiBmaWxsPSJ1cmwoI2dyYWRpZW50KSIvPgo8ZGVmcz4KPGxpbmVhckdyYWRpZW50IGlkPSJncmFkaWVudCIgeDE9IjAiIHkxPSIwIiB4Mj0iMjAwIiB5Mj0iMTIwIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIG9mZnNldD0iMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiM5OTk5OTk7c3RvcC1vcGFjaXR5OjEiLz4KPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdHlsZT0ic3RvcC1jb2xvcjojZmZmZmZmO3N0b3Atb3BhY2l0eToxIi8+CjwvbGluZWFyR3JhZGllbnQ+CjwvZGVmcz4KPHN2ZyB4PSI1MCIgeT0iMzAiIHdpZHRoPSIxMDAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCAxMDAgNjAiIGZpbGw9Im5vbmUiPgo8dGV4dCB4PSI1MCIgeT0iMzUiIGZvbnQtZmFtaWx5PSJBcmlhbCIgZm9udC1zaXplPSIxNCIgZmlsbD0iIzMzMyIgdGV4dC1hbmNob3I9Im1pZGRsZSI+5Zu+54mH5Y2gPC90ZXh0Pgo8L3N2Zz4KPC9zdmc+"
    };
  },
  computed: {
    contentTypeText() {
      const type = this.info.type;
      if (type === 1) return "线上/图文";
      if (type === 2) return "线上/视频";
      if (type === 3) return "线下/文件";
      return "--";
    }
  },
  created() {
    this.handleShow();
  },
  methods: {
    handleShow() {
      // 获取 id，优先从 templateMaterialsSharePO 中获取
      const id =
        (this.rowItem &&
          this.rowItem.templateMaterialsSharePO &&
          this.rowItem.templateMaterialsSharePO.id) ||
        (this.rowItem && this.rowItem.id);

      if (!id) {
        this.$common.showMsg("error", "缺少物料ID");
        return;
      }

      // 调用接口获取详情
      templateMaterialsShareApi
        .fetchById(id)
        .then(res => {
          const responseData = res.data || {};
          const sharePO = responseData.templateMaterialsSharePO || {};
          const classification = responseData.templateClassification || {};

          // 处理标题
          let title = sharePO.title || "--";
          if (sharePO.titleJson) {
            try {
              const titleList =
                typeof sharePO.titleJson === "string"
                  ? JSON.parse(sharePO.titleJson)
                  : sharePO.titleJson;
              if (Array.isArray(titleList) && titleList.length > 0) {
                title = titleList
                  .map(item => item.titleName || item)
                  .filter(Boolean)
                  .join("、");
              }
            } catch (e) {
              console.error("解析标题失败:", e);
            }
          }

          // 构建 info 对象
          this.info = {
            ...sharePO,
            title: title,
            classificationName: classification.name || "--",
            type: sharePO.type || 1,
            state: sharePO.state,
            orderNo: sharePO.orderNo || 0,
            abrowseNum: sharePO.abrowseNum || 0,
            alikeNum: sharePO.alikeNum || 0,
            acollectNum: sharePO.acollectNum || 0,
            aforwardNum: sharePO.aforwardNum || 0,
            canDownloadMaterial: sharePO.canDownloadMaterial,
            coverImage: sharePO.coverImage || ""
          };

          // 处理内容
          if (sharePO.content) {
            try {
              const content =
                typeof sharePO.content === "string"
                  ? JSON.parse(sharePO.content)
                  : sharePO.content;
              if (Array.isArray(content) && content.length > 0) {
                // 如果是数组，提取所有 content 字段并合并
                this.contentHtml = content
                  .map(item => (item && item.content ? item.content : ""))
                  .filter(Boolean)
                  .join("<br/>");
              } else if (typeof content === "string") {
                this.contentHtml = content;
              } else {
                this.contentHtml = sharePO.content;
              }
            } catch (e) {
              // 如果不是 JSON，直接使用原值
              this.contentHtml = sharePO.content;
            }
          } else {
            this.contentHtml = "--";
          }

          // 处理素材文案
          if (sharePO.materialText) {
            try {
              const parsedText =
                typeof sharePO.materialText === "string"
                  ? JSON.parse(sharePO.materialText)
                  : sharePO.materialText;
              this.materialTextList = Array.isArray(parsedText)
                ? parsedText
                : [];
            } catch (e) {
              // 不是JSON格式（视频的单个文案），直接作为单个元素数组
              this.materialTextList = [sharePO.materialText];
            }
          } else {
            this.materialTextList = [];
          }

          // 处理素材图片
          if (sharePO.materialImg) {
            try {
              const parsedImg =
                typeof sharePO.materialImg === "string"
                  ? JSON.parse(sharePO.materialImg)
                  : sharePO.materialImg;
              if (Array.isArray(parsedImg)) {
                this.materialImgList = parsedImg.map(item => {
                  if (typeof item === "string") return item;
                  if (item && item.url) return item.url;
                  return item;
                });
              } else {
                this.materialImgList = [];
              }
            } catch (e) {
              this.materialImgList = [];
            }
          } else {
            this.materialImgList = [];
          }

          // 如果是视频类型，处理视频
          if (sharePO.type === 2 && sharePO.materialImg) {
            this.videoList = [...this.materialImgList];
          } else {
            this.videoList = [];
          }
        })
        .catch(err => {
          console.error("获取详情失败:", err);
          this.$common.showMsg("error", "获取详情失败");
        });
    },
    handleBack() {
      this.$emit("handleShow", "", 1);
    }
  }
};
</script>

<style lang="scss" scoped>
.el-card {
  margin-bottom: 10px;
  &:last-child {
    margin-bottom: 0;
  }
}

.info-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 20px;
  font-size: 14px;
  color: #2e2f3e;
}

.thumbnail-box {
  margin-right: 20px;
  .thumbnail {
    width: 140px;
    height: 93px;
    object-fit: cover;
  }
}
.article-info {
  .article-name {
    color: #000000;
    font-size: 16px;
    margin-bottom: 10px;
  }
  .article-describe {
    color: #6c6c6c;
    font-size: 13px;
  }
}
.virtual-data {
  display: flex;
  flex-wrap: wrap;
  gap: 30px;

  .info-item {
    position: relative;
    &:not(:last-child)::after {
      content: "";
      position: absolute;
      right: -15px;
      top: 4px;
      width: 1px;
      bottom: 2px;
      background-color: #2e2f3e;
    }
  }
  & + label {
    padding-left: 30px;
  }
}

.article-details {
  .content-text {
    font-size: 14px;
    color: #2e2f3e;
    line-height: 1.8;
    word-break: break-all;
  }
}

.copy-text-list {
  display: flex;
  flex-direction: column;
  gap: 8px;

  .copy-text {
    word-break: break-all;
    line-height: 1.6;
  }
}

.image-gallery {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;

  .share-image {
    width: 80px;
    height: 80px;
    object-fit: cover;
    border-radius: 6px;
    border: 1px solid #e4e7ed;
  }
}

.video-gallery {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;

  .share-video {
    width: 200px;
    height: 120px;
    border-radius: 6px;
    border: 1px solid #e4e7ed;
  }
}
.share-materials {
  label {
    width: 100px;
    display: inline-block;
    text-align: right;
  }
}
</style>
